import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

function BackButton() {
  return (
    <Link className="btn btn-soft btn-back" to="/">
      Back
    </Link>
  );
}

export default function LegalPage({ title, description, path, effectiveDate, children }) {
  return (
    <section className="section page-document">
      <Seo title={`${title} | RIME | Bookkeeping + Payroll`} description={description} path={path} />
      <div className="container page-document-inner" data-reveal>
        <BackButton />
        <p className="eyebrow">Effective Date: {effectiveDate}</p>
        <h1 className="display-2">{title}</h1>
        <div className="legal-prose">{children}</div>
        <div className="page-document-footer">
          <BackButton />
        </div>
      </div>
    </section>
  );
}
